import { Dialog } from "@base-ui/react/dialog";
import styles from "./TimeoutDialog.module.css";

interface RecommenderTimeoutDialogProps {
  open: boolean;
  onClose: () => void;
  onSnooze: () => void;
  onGoToQualtrics: () => void;
}

const RecommenderTimeoutDialog = ({
  open,
  onClose,
  onSnooze,
  onGoToQualtrics,
}: RecommenderTimeoutDialogProps) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && open) {
      onSnooze();
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Backdrop className={styles.backdrop} />

        <Dialog.Viewport className={styles.viewport}>
          <Dialog.Popup
            className={styles.longPopup}
            data-cy="recommender-timeout-dialog"
          >
            <Dialog.Title
              className={styles.title}
              data-cy="recommender-timeout-dialog-title"
            >
              Reminder
            </Dialog.Title>

            <Dialog.Description className={styles.description}>
              We hope you've enjoyed this page. Please now complete the
              Qualtrics survey.
            </Dialog.Description>

            <div className={styles.actions}>
              <button
                type="button"
                className={styles.secondaryButton}
                onClick={onClose}
                data-cy="stop-button"
              >
                Don't show again
              </button>

              <button
                type="button"
                className={styles.secondaryButton}
                onClick={onSnooze}
                data-cy="snooze-button"
              >
                Snooze for 3 minutes
              </button>

              <button
                type="button"
                className={styles.primaryButton}
                onClick={onGoToQualtrics}
                data-cy="go-to-survey-button"
              >
                Go to Qualtrics
              </button>
            </div>
          </Dialog.Popup>
        </Dialog.Viewport>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default RecommenderTimeoutDialog;
